import createAPI from '../axios'
//import { config } from 'vue/types/umd';

//成绩管理系统相关API

const scoreManageSkillsTraining = {
    //成绩设置
    setting: {
        //默认设置
        defaultConfig: {
            query: config => createAPI('/scoreManageSkillsTraining/setting/defaultConfig/query', 'post', config),

            save: config => createAPI('/scoreManageSkillsTraining/setting/defaultConfig/save', 'post', config),
        },
        //登分时间设置
        time: {
            initCombo: config => createAPI('/scoreManageSkillsTraining/setting/time/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManageSkillsTraining/setting/time/queryList', 'post', config),

            saveTime: config => createAPI('/scoreManageSkillsTraining/setting/time/saveTime', 'post', config),

            saveBkTime: config => createAPI('/scoreManageSkillsTraining/setting/time/saveBkTime', 'post', config),

            saveDbkTime: config => createAPI('/scoreManageSkillsTraining/setting/time/saveDbkTime', 'post', config),
        },
        //科目设置
        subject: {
            queryList: config => createAPI('/scoreManageSkillsTraining/setting/subject/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageSkillsTraining/setting/subject/initCombo', 'post', config),

            updateSubjectInfo: config => createAPI('/scoreManageSkillsTraining/setting/subject/updateSubjectInfo', 'post', config),

            scoreDefaultConfig: config => createAPI('/scoreManageSkillsTraining/setting/subject/scoreDefaultConfig', 'post', config),

            loadDfConfig: config => createAPI('/scoreManageSkillsTraining/setting/subject/loadDfConfig', 'post', config),

            saveScoreSet: config => createAPI('/scoreManageSkillsTraining/setting/subject/saveScoreSet', 'post', config),

            importScoreConfig: config => createAPI('/scoreManageSkillsTraining/setting/subject/importScoreConfig', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageSkillsTraining/setting/subject/loadCourseCombo', 'post', config),

            loadClassTree: config => createAPI('/scoreManageSkillsTraining/setting/subject/loadClassTree', 'post', config),

            saveScoreBatchSet: config => createAPI('/scoreManageSkillsTraining/setting/subject/saveScoreBatchSet', 'post', config),
        },
        //登分人员设置
        person: {
            queryList: config => createAPI('/scoreManageSkillsTraining/setting/person/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageSkillsTraining/setting/person/initCombo', 'post', config),

            queryTeaList: config => createAPI('/scoreManageSkillsTraining/setting/person/queryTeaList', 'post', config),

            queryTeaStuList: config => createAPI('/scoreManageSkillsTraining/setting/person/queryTeaStuList', 'post', config),

            saveTea: config => createAPI('/scoreManageSkillsTraining/setting/person/saveTea', 'post', config),

            queryStuList: config => createAPI('/scoreManageSkillsTraining/setting/person/queryStuList', 'post', config),

            queryClassStuTree: config => createAPI('/scoreManageSkillsTraining/setting/person/queryClassStuTree', 'post', config),

            saveAddStu: config => createAPI('/scoreManageSkillsTraining/setting/person/saveAddStu', 'post', config),

            saveStu: config => createAPI('/scoreManageSkillsTraining/setting/person/saveStu', 'post', config),

            queryDelStuList: config => createAPI('/scoreManageSkillsTraining/setting/person/queryDelStuList', 'post', config),

            delStu: config => createAPI('/scoreManageSkillsTraining/setting/person/delStu', 'post', config),

            queryClassCourseList: config => createAPI('/scoreManageSkillsTraining/setting/person/queryClassCourseList', 'post', config),

            syncStuList: config => createAPI('/scoreManageSkillsTraining/setting/person/syncStuList', 'post', config),

            saveTeaStu: config => createAPI('/scoreManageSkillsTraining/setting/person/saveTeaStu', 'post', config),

            addStuScoreData: config => createAPI('/scoreManageSkillsTraining/setting/person/addStuScoreData', 'post', config),

            queryTeaAuthList: config => createAPI('/scoreManageSkillsTraining/setting/person/queryTeaAuthList', 'post', config),

            saveTeaAuth: config => createAPI('/scoreManageSkillsTraining/setting/person/saveTeaAuth', 'post', config),

            delTeaAuth: config => createAPI('/scoreManageSkillsTraining/setting/person/delTeaAuth', 'post', config),

            findTeaAuthClass: config => createAPI('/scoreManageSkillsTraining/setting/person/findTeaAuthClass', 'post', config),
        },
        //补考教师设置
        resitTeacher: {
            initCombo: config => createAPI('/scoreManageSkillsTraining/setting/resitTeacher/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManageSkillsTraining/setting/resitTeacher/queryList', 'post', config),

            queryTeaList: config => createAPI('/scoreManageSkillsTraining/setting/resitTeacher/queryTeaList', 'post', config),

            saveTea: config => createAPI('/scoreManageSkillsTraining/setting/resitTeacher/saveTea', 'post', config),

            initBkCourseInfo: config => createAPI('/scoreManageSkillsTraining/setting/resitTeacher/initBkCourseInfo ', 'post', config),
        },
        //大补考教师设置
        finalResitTeacher: {
            queryList: config => createAPI('/scoreManageSkillsTraining/setting/finalResitTeacher/queryList', 'post', config),

            initData: config => createAPI('/scoreManageSkillsTraining/setting/finalResitTeacher/initData', 'post', config),

            queryTeaList: config => createAPI('/scoreManageSkillsTraining/setting/finalResitTeacher/queryTeaList', 'post', config),

            saveTea: config => createAPI('/scoreManageSkillsTraining/setting/finalResitTeacher/saveTea', 'post', config),
        },
        //免修设置
        exemptStudy: {
            queryList: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/queryList', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/loadCourseCombo', 'post', config),

            loadStuMxmd: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/loadStuMxmd', 'post', config),

            queStuList: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/queStuList', 'post', config),

            saveMxStu: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/saveMxStu', 'post', config),

            loadStuCourseListData: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/loadStuCourseListData', 'post', config),

            saveStuMxCourse: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/saveStuMxCourse', 'post', config),

            initCombo: config => createAPI('/scoreManageSkillsTraining/setting/exemptStudy/initCombo', 'post', config),
        },
        //缓考成绩设置
        delay: {
            initCombo: config => createAPI('/scoreManageSkillsTraining/setting/delay/initCombo', 'post', config),

            queryList: config => createAPI('/scoreManageSkillsTraining/setting/delay/queryList', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageSkillsTraining/setting/delay/loadCourseCombo', 'post', config),

            loadStuCourseListData: config => createAPI('/scoreManageSkillsTraining/setting/delay/loadStuCourseListData', 'post', config),

            loadStuHkmd: config => createAPI('/scoreManageSkillsTraining/setting/delay/loadStuHkmd', 'post', config),

            queStuList: config => createAPI('/scoreManageSkillsTraining/setting/delay/queStuList', 'post', config),

            saveHkStu: config => createAPI('/scoreManageSkillsTraining/setting/delay/saveHkStu', 'post', config),

            saveStuHkCourse: config => createAPI('/scoreManageSkillsTraining/setting/delay/saveStuHkCourse', 'post', config),
        }
    },
    //学生个人成绩查询
    stuPersonalScore: {
        initCombo: config => createAPI('/scoreManageSkillsTraining/stuPersonalScore/initCombo', 'post', config),

        list: config => createAPI('/scoreManageSkillsTraining/stuPersonalScore/list', 'post', config),
    },

    //成绩查询与统计
    query: {
        //整班成绩查询
        classScoreInfo: {
            queryList: config => createAPI('/scoreManageSkillsTraining/query/classScoreInfo/queryList', 'post', config),

            initData: config => createAPI('/scoreManageSkillsTraining/query/classScoreInfo/initData', 'post', config),

            initStuScoreInfo: config => createAPI('/scoreManageSkillsTraining/query/classScoreInfo/initStuScoreInfo', 'post', config),

            exportScoreInfo: config => createAPI('/scoreManageSkillsTraining/query/classScoreInfo/exportScoreInfo', 'post', config),

            batchExport: config => createAPI('/scoreManageSkillsTraining/query/classScoreInfo/batchExport', 'post', config),
        },
        //学年学期成绩查询
        semesterScore: {
            queryList: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/queryList', 'post', config),

            initData: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/initData', 'post', config),

            saveSet: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/saveSet', 'post', config),

            loadStuScoreInfo: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/loadStuScoreInfo', 'post', config),

            exportScoreInfo: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/exportScoreInfo', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/batchExport', 'post', config),

            batchScoreExport: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/batchScoreExport', 'post', config),

            batchWarnExport: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/batchWarnExport', 'post', config),

            initExCombo: config => createAPI('/scoreManageSkillsTraining/query/semesterScore/initExCombo', 'post', config),
        },
        //不合格科目查询
        failSubject: {
            queryList: config => createAPI('/scoreManageSkillsTraining/query/failSubject/queryList', 'post', config),

            initData: config => createAPI('/scoreManageSkillsTraining/query/failSubject/initData', 'post', config),

            queryExamineList: config => createAPI('/scoreManageSkillsTraining/query/failSubject/queryExamineList', 'post', config),

            exportSingle: config => createAPI('/scoreManageSkillsTraining/query/failSubject/exportSingle', 'post', config),

            exportBatch: config => createAPI('/scoreManageSkillsTraining/query/failSubject/exportBatch', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageSkillsTraining/query/failSubject/loadExportClassCombo', 'post', config),

            loadExportMajorCombo: config => createAPI('/scoreManageSkillsTraining/query/failSubject/loadExportMajorCombo', 'post', config),
        },
        //学生成绩单
        stuScoreList: {
            queryList: config => createAPI('/scoreManageSkillsTraining/query/stuScoreList/queryList', 'post', config),

            initCombo: config => createAPI('/scoreManageSkillsTraining/query/stuScoreList/initCombo', 'post', config),

            queryStuScoreInfo: config => createAPI('/scoreManageSkillsTraining/query/stuScoreList/queryStuScoreInfo', 'post', config),

            exportSingle: config => createAPI('/scoreManageSkillsTraining/query/stuScoreList/exportSingle', 'post', config),

            exportBatch: config => createAPI('/scoreManageSkillsTraining/query/stuScoreList/exportBatch', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageSkillsTraining/query/stuScoreList/loadExportClassCombo', 'post', config),
        },
        //大补考名单
        finalResitStuList: {
            queryList: config => createAPI('/scoreManageSkillsTraining/query/finalResitStuList/queryList', 'post', config),

            initData: config => createAPI('/scoreManageSkillsTraining/query/finalResitStuList/initData', 'post', config),

            queryStuList: config => createAPI('/scoreManageSkillsTraining/query/finalResitStuList/queryStuList', 'post', config),

            singleExport: config => createAPI('/scoreManageSkillsTraining/query/finalResitStuList/singleExport', 'post', config),

            loadExportClassCombo: config => createAPI('/scoreManageSkillsTraining/query/finalResitStuList/loadExportClassCombo', 'post', config),

            batchExport: config => createAPI('/scoreManageSkillsTraining/query/finalResitStuList/batchExport', 'post', config),
        },
    },
    register: {
        //班级学期成绩登记
        classSemesterScore: {
            initData: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/initData', 'post', config),

            loadMajorCombo: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadMajorCombo', 'post', config),

            loadClassCombo: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadClassCombo', 'post', config),

            queryList: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/queryList', 'post', config),

            loadClassCourseInfo: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadClassCourseInfo', 'post', config),

            loadDfConfig: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadDfConfig', 'post', config),

            loadScoreConvertConfig: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadScoreConvertConfig', 'post', config),

            loadStuList: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadStuList', 'post', config),

            loadLockState: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadLockState', 'post', config),

            saveScoreSet: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/saveScoreSet', 'post', config),

            saveStuScore: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/saveStuScore', 'post', config),

            submitStuScore: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/submitStuScore', 'post', config),

            exportFile: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/exportFile', 'post', config),

            importFile: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/importFile', 'post', config),

            loadExemptStuList: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/loadExemptStuList', 'post', config),

            updateExemptStuScore: config => createAPI('/scoreManageSkillsTraining/register/classSemesterScore/updateExemptStuScore', 'post', config),
        },
        delayScore: {
            initData: config => createAPI('/scoreManageSkillsTraining/register/delayScore/initData', 'post', config),

            queryList: config => createAPI('/scoreManageSkillsTraining/register/delayScore/queryList', 'post', config),

            loadClassCourseTreeByScoreType: config => createAPI('/scoreManageSkillsTraining/register/delayScore/loadClassCourseTreeByScoreType', 'post', config),

            loadDfConfig: config => createAPI('/scoreManageSkillsTraining/register/delayScore/loadDfConfig', 'post', config),

            loadStuListByScoreType: config => createAPI('/scoreManageSkillsTraining/register/delayScore/loadStuListByScoreType', 'post', config),

            loadLockState: config => createAPI('/scoreManageSkillsTraining/register/delayScore/loadLockState', 'post', config),

            saveStuScore: config => createAPI('/scoreManageSkillsTraining/register/delayScore/saveStuScore', 'post', config),

            queryDelayScoreRecordList: config => createAPI('/scoreManageSkillsTraining/register/delayScore/queryDelayScoreRecordList', 'post', config),

            exportDelayScoreRecord: config => createAPI('/scoreManageSkillsTraining/register/delayScore/exportDelayScoreRecord', 'post', config),

            initReportData: config => createAPI('/scoreManageSkillsTraining/register/delayScore/initReportData', 'post', config),

            loadCourseCombo: config => createAPI('/scoreManageSkillsTraining/register/delayScore/loadCourseCombo', 'post', config),

            queryReportInfo: config => createAPI('/scoreManageSkillsTraining/register/delayScore/queryReportInfo', 'post', config),

            exportReportInfo: config => createAPI('/scoreManageSkillsTraining/register/delayScore/exportReportInfo', 'post', config),

            printReportInfo: config => createAPI('/scoreManageSkillsTraining/register/delayScore/printReportInfo', 'post', config),
        },
        //成绩提交管理
        submitManage: {
            queryList: config => createAPI('/scoreManageAdultEducation/register/submitManage/queryList', 'post', config),

            sendBack: config => createAPI('/scoreManageAdultEducation/register/submitManage/sendBack', 'post', config),

            batchExport: config => createAPI('/scoreManageAdultEducation/register/submitManage/batchExport', 'post', config),
        },
    },
    statistics: {
        examQualityAnalysis: {
            initCombo: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/initCombo', 'post', config),

            list: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/list', 'post', config),

            query: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/query', 'post', config),

            export: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/export', 'post', config),

            print: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/print', 'post', config),

            save: config => createAPI('/scoreManageAdultEducation/statistics/examQualityAnalysis/save', 'post', config),
        },
        //成绩登记表
        subjectScoreReport: {
            query: config => createAPI('/scoreManageAdultEducation/statistics/subjectScoreReport/query', 'post', config),

            export: config => createAPI('/scoreManageAdultEducation/statistics/subjectScoreReport/export', 'post', config),

            print: config => createAPI('/scoreManageAdultEducation/statistics/subjectScoreReport/print', 'post', config),
        },
    }
};

export default scoreManageSkillsTraining;



// WEBPACK FOOTER //
// ./src/api/modules/scoreManageSkillsTraining.js